/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Workflow {
  ONBOARDING = 'ONBOARDING',
}
